<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getNoticeList_data.noticeTitle"
          placeholder="请输入标题"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getNoticeList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addNotice"
          @click=" $form('addNotice') "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >发布通知
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getNoticeList'
      api='getNoticeList'
      updateapi='updateCustomAttr'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addNotice:    [ "新增通知", "el-icon-circle-plus" ],
        updateCustomAttr: [ "修改通知", "el-icon-edit-outline"],
        $succeed$: getNoticeList
      }'
      @opened="
      Myformdata.noticeType=Myformdata.noticeType||1;
      Myformdata.noticeReceiverId=Myformdata.noticeReceiverId||1;
      Myformdata.noticeStatus=Myformdata.noticeStatus||2
      "
      @close='$form("addNotice","reset")' 
      @confirm='myform'>
      <template v-slot:noticeType="{Myformdata}" >
        <el-select v-model='Myformdata.noticeType' clearable @change="noticeTypeChange">
            <el-option
                v-for="item in noticeTypeAll||[]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:noticeReceiverId="{Myformdata}" >
        <el-input v-if="Myformdata.noticeType==1" disabled v-model="allPerson"></el-input>
        <el-select v-if="Myformdata.noticeType==2" v-model='Myformdata.noticeReceiverId' clearable >
            <el-option
                v-for="item in getRoleList_data.data||[]"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId">
            </el-option>
        </el-select>
        <el-select v-if="Myformdata.noticeType==3" v-model='Myformdata.noticeReceiverId' clearable >
            <el-option
                v-for="item in getPostList_data.data||[]"
                :key="item.postId"
                :label="item.postName"
                :value="item.postId">
            </el-option>
        </el-select>
        <el-select v-if="Myformdata.noticeType==4||Myformdata.noticeType==5" v-model='Myformdata.noticeReceiverId' clearable @change="projectChange" >
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select v-if="Myformdata.noticeType==5" v-model='theNoticeReceiverIdUserId' clearable >
            <el-option
                v-for="item in getProjectUserAll_data.data||[]"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:noticeStatus="{Myformdata}" >
        <el-radio v-model="Myformdata.noticeStatus" :label='1'>保存</el-radio>
        <el-radio v-model="Myformdata.noticeStatus" :label='2'>立即发布</el-radio>
  	  </template>
    </myform>
    <myform view.getNoticeDetails='通知详情' @opened="form=>form.title += ' | @' + row.noticeTitle" >
      <div v-if='row'>
        <div>标题 :  {{getNoticeDetails_data.data.noticeTitle}}</div>
        <div>内容 :  {{getNoticeDetails_data.data.noticeContent}}</div>
        <div>接收者 :  {{getNoticeDetails_data.data.noticeReceiverName}}</div>
        <!-- <div>类型 :  {{getNoticeDetails_data.data.noticeType}}</div> -->
        <div>创建时间 :  {{getNoticeDetails_data.data.createtime}}</div>
        <div>发布时间 :  {{getNoticeDetails_data.data.noticeReportTime}}</div>
        <div>已读数量 :  {{getNoticeDetails_data.data.noticeReadNum}}</div>
        <div style="color:red;">未读数量 :  {{getNoticeDetails_data.data.noticeUnReadNum}}</div>
        <!-- <div>明细 :  </div>
        <div v-for="item in getNoticeDetails_data.data.sysNoticeReceiveList" :key="item.nrUuid" >
          {{item.mtName+' :  '+item.createtime}}
        </div> -->
      </div>
      <hide slot='noticeId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
        //1全员2指定角色3指定岗位4指定项目
        allPerson:"全员",
        theNoticeType:1,
        noticeTypeAll:[
            {id:1,name:"全员"},
            {id:2,name:"角色"},
            {id:3,name:"岗位"},
            {id:4,name:"项目"},
            {id:5,name:"人员"},
        ],
        theNoticeReceiverIdUserId:"",
        theProjectId:"",
        noticeId: null,

        tableColums_getNoticeList: {
            $selection: false,

            noticeTitle: '标题',

            noticeContent: '内容',

            noticeType: [ '类型', , '@v-if: 1:全员, 2:角色 , 3:岗位, 4:项目 , 5:个人' ],//1全员2指定角色3指定岗位4指定项目
            // noticeReceiverId: '接收者',// [ '接收者', , '@v-if: 1:全员, 2:角色 , 3:岗位, 4:项目 , 5:个人' ],//接收者(1全员 2角色id 3岗位id 4项目id)

            createtime: '创建时间',

            noticeReportTime: '发布时间',

            // noticeStatus: [ '状态', , '@v-if: 1:已保存, 2:已发布' ],

            $operation: [
            '操作', 200,
            this.getNoticeDetails && `@text: 详情#success
            @click: $form("getNoticeDetails",$this.row = $row),getNoticeDetails({noticeId:$row.noticeId})
            `,
            this.reportNotice && `@text: 发布#danger
            @v-if: $row.noticeStatus == 1
            @click: _confirm('确定发布?')
                    .trigger('reportNotice',{noticeId:$row.noticeId})
                    .trigger('getNoticeList')
            `,
            ],

        },

    };
  },

  watch: {
    
  },

  methods: {
      projectChange(e){
        this.theProjectId=e;
        this.theNoticeReceiverIdUserId="";
        if(this.theProjectId&&this.theNoticeType==5){
          this.getProjectUserAll({projectId:this.theProjectId});
        }else{
          this.getProjectUserAll_data.data=[];
        }
      },
      noticeTypeChange(e){
          this.Myformdata.noticeReceiverId='';
          this.theNoticeType=e;
          switch(e){
            case 1:
                this.Myformdata.noticeReceiverId=1;
                break;
            case 2:
                this.getRoleList();
                break;
            case 3:
                this.getPostList();
                break;
            case 4:
                this.getProjectList({pageSize:0});
                break;
            case 5:
                this.getProjectList({pageSize:0});
                break;
          }
      },
      myform(submit, Myformdata) {
        if(this.theNoticeType==5){
          if(!this.theNoticeReceiverIdUserId){
            this.$message({
              message: '请选择接收者!',
              type: 'warning'
            });
            return;
          }
          Myformdata.noticeReceiverId = this.theNoticeReceiverIdUserId;
        }
      submit();
    },
  },

  created() {
    this.getNoticeList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/notice/NoticeManage.vue